import { RadioGroupButtons } from '@cimplico/components';
import { ExclamationTriangleIcon } from '@heroicons/react/20/solid';
import { Controller, useFormContext } from 'react-hook-form';
import { useWorkpaperContext } from '../../../providers/WorkpaperProvider';
import { TrialBalanceAccountingBasisEnum, WorkpaperSourceEnum } from '../../../types/workpaper';

type TrialBalanceSectionProps = {
    isDisabled: boolean;
};

function TrialBalanceSection({ isDisabled }: TrialBalanceSectionProps): JSX.Element {
    const { control, formState, clearErrors } = useFormContext();
    const { provider } = useWorkpaperContext();

    return (
        <div className="flex flex-col gap-2">
            <h3 className="font-medium text-gray-800 text-lg">Trial Balance</h3>
            <Controller
                name="accountingBasis"
                control={control}
                render={({ field: { value, onChange } }): JSX.Element => (
                    <div className="flex flex-col gap-2">
                        <div>
                            <RadioGroupButtons
                                title="Accounting Basis"
                                groupName="accountingBasis"
                                onChange={(e): void => {
                                    onChange(e.target.value);
                                    clearErrors('accountingBasis');
                                }}
                                value={value}
                                options={[
                                    {
                                        label: 'Accrual',
                                        value: TrialBalanceAccountingBasisEnum.ACCRUAL,
                                        disabled: isDisabled,
                                    },
                                    {
                                        label: 'Cash',
                                        value: TrialBalanceAccountingBasisEnum.CASH,
                                        disabled: isDisabled,
                                    },
                                ]}
                            />
                        </div>
                        {formState.errors.accountingBasis?.message && (
                            <p className="text-sm font-normal text-red-500">{formState.errors.accountingBasis?.message?.toString()}</p>
                        )}
                    </div>
                )}
            />
            {formState.dirtyFields.accountingBasis && (
                <div className="flex items-start gap-2 text-sm">
                    <ExclamationTriangleIcon className="text-yellow-600 w-4 h-4 shrink-0" />
                    <p className="text-gray-500 leading-4">
                        {provider === WorkpaperSourceEnum.XERO
                            ? 'Changing this will automatically refresh the trial balance which may affect the status of current worksheets.'
                            : 'You will be prompted to replace the trial balance which may affect the status of current worksheets..'}
                    </p>
                </div>
            )}
        </div>
    );
}

export default TrialBalanceSection;
